export const getRuntimeEnvironment = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    if (hostname.includes('iwoca-dev.co.uk')) {
      return 'STAGING';
    } else if (hostname.includes('localhost')) {
      return 'LOCAL';
    } else {
      return 'PRODUCTION';
    }
  }

  return 'UNKNOWN';
};
